export const Role = {
  Administrador: 'ADMINISTRADOR',
  GestorNacional: 'GESTOR_NACIONAL',
  GestorUF: 'GESTOR_UF',
  CertificadoListarErro: 'CERTIFICADO_GRID_ERROS_LISTAR',
  CertificadoListar: 'CERTIFICADO_GRID_LISTAR',
  CertificadoReprocessarErros: 'CERTIFICADO_REPROCESSAR_ERROS',
  CertificadoReprocessar: 'CERTIFICADO_REPROCESSAR',
  CertificadoEnvioEmail: 'CERTIFICADO_ENVIO_EMAIL',
  CertificadoExcluir: 'CERTIFICADO_EXCLUIR',
  CertificadoDetalhar: 'CERTIFICADO_DETALHAR',
  CertificadoDetalharSituacao: 'CERTIFICADO_DETALHAR_SITUACAO',
  CertificadoAlterar: 'CERTIFICADO_ALTERAR',
};
